module.exports = __webpack_public_path__ + "img/19.1dd2de54.jpg";